import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { SEO } from '../components/SEO';

export const Disclaimer: React.FC = () => {
  const sections = [
    {
      title: 'Website Disclaimer',
      content: [
        'The information provided on our website is for general informational purposes only',
        'All information is provided in good faith, however we make no representation or warranty of any kind',
        'We do not guarantee the accuracy, adequacy, validity, reliability, availability, or completeness of any information'
      ]
    },
    {
      title: 'External Links Disclaimer',
      content: [
        'Our website may contain links to external websites that are not provided or maintained by us',
        'We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on external websites',
        'We are not responsible for the content or privacy practices of linked websites'
      ]
    },
    {
      title: 'Professional Disclaimer',
      content: [
        'The information provided is for general guidance on matters of interest only',
        'We take precautions to ensure content is current and accurate, but errors can occur',
        'Given the changing nature of laws and regulations, there may be delays or inaccuracies in the information'
      ]
    },
    {
      title: 'Fair Use Disclaimer',
      content: [
        'This website may contain copyrighted material not always specifically authorized by the copyright owner',
        'We make such material available to advance understanding of various issues',
        'We believe this constitutes fair use under copyright law'
      ]
    },
    {
      title: 'Contact Us',
      content: [
        'If you have any questions about this Disclaimer, please contact us at contact@cemates.me'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Disclaimer"
        description="Legal disclaimer for Cemates.me. Information about website usage, external links, and professional advice."
        canonical="/disclaimer"
      />
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6">
          {/* Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-6">
              <AlertTriangle className="w-5 h-5 text-foreground" />
            </div>
            <h1 className="text-3xl font-semibold text-foreground mb-3">
              Disclaimer
            </h1>
            <p className="text-muted-foreground text-sm">
              Last updated: April 27, 2024
            </p>
          </div>

          {/* Intro */}
          <div className="mb-12">
            <p className="text-muted-foreground leading-relaxed">
              The information contained on Cemates.me is for general information purposes only. 
              We assume no responsibility for errors or omissions in the contents of this website.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-lg font-medium text-foreground mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-muted-foreground text-sm leading-relaxed flex gap-3">
                      <span className="text-muted-foreground/50 select-none">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
